import React from 'react';

import { autorun } from 'mobx';
import type { IAutorunOptions, IReactionPublic } from 'mobx';

const useAutorun = function (
  reaction: (r: IReactionPublic) => any,
  deps: React.DependencyList,
  options?: IAutorunOptions
): void {
  React.useEffect(() => autorun(reaction, options), deps);
};

export default useAutorun;
